import "../Verification/Verification.css";
import userImage from "../../assets/images/user-img.jpg";
import React, { useEffect, useState } from "react";
import InputComponent from "../../Components/InputComponent/InputComponent";
import VerificationInput from "./Verification InputComponent/VerificationInput";
import VerificationOtp from "./VerificationOTP/VerificationOtp";
import VerificationOutPut from "./VerificationOutUpt/VerificationOutPut";
import { ManageApis } from "../../AppServices/ManageApi";
import moment from "moment";
import Loader from "../../Components/LoaderComponent/Loader";
import { useLocation } from "react-router-dom";
import { UsernameformatingValue, formatingValue, getLocalStorage, splitCamelCase } from "../../Functions/Utils";
import AlertBox from "../../Components/AlertBox/AlertBox";
import HeaderComponent from "@arco-design/web-react/es/Layout/header";
import HeaderSection from "../../Components/HeaderSection";

function VerificationScreen({ selectedMenu, fields, headerName, discription, discriptionHead, setisToggled, isToggled }) {
  // alert(headerName)

  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [onChangeDta, setOnChangeDta] = useState({});
  const [haveOTPSection, setHaveOTPSection] = useState(false);
  const [response, setResponse] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  useEffect(() => {

    // //console.log(fields, selectedMenu)
    setIsVerified(false)
    setResponse(null)
    setHaveOTPSection(false)
    setOnChangeDta({})
    return (() => {
      setOnChangeDta({})
    })
  }, [pathname])

  useEffect(() => {
    setOtp(['', '', '', '', '', '']);
  }, [])



  useEffect(() => {
    // //console.log(onChangeDta)
    setOnChangeDta({})
  }, [isVerified])



  const handleSubmit = async () => {
    // ""
    // //console.log(selectedMenu)
    setIsLoading(true)
    let param;
    let result;
    let headers
    let request_body
    // ""
    switch (selectedMenu) {
      case "AADHARVERIFICATION":

        if (!onChangeDta?.aadhaarNumber || onChangeDta?.aadhaarNumber?.length <= 11) {
          setIsLoading(false)
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Aadhaar number should be a 12 digit number",

            isfalse: true
          }));
          return 0
        }
        param = {
          // userId: getLocalStorage("clientId"),
          aadhaarNumber: `${onChangeDta?.aadhaarNumber}`,
        };
        // param = `aadhaarNumber=${onChangeDta?.aadhaarNumber}&UserId=${getLocalStorage("clientId")}`
        result = await ManageApis(
          "post",
          `${global.InitiateAadhaarVerification}`, param, {

          'Content-Type': 'application/json',
          "UserId": getLocalStorage("userId"),
          "AccountId": getLocalStorage("oldAccountId")

        },

        );
        // ""
        console.log(result)
        if (result.message === "Success" && result.response_data?.message !== "Your trying limit is over, please contact with support team." && result.response_data?.message == "OTP sent successfully") {
          setResponse(result.response_data);
          setHaveOTPSection(true);
          setIsLoading(false)
        } else {
          //console.log(result)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: result.message === "Success" ? (result?.response_data?.message === "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" : (typeof(result.response_data?.message) === "string" ? result?.response_data?.message : result.message || result.message)) : result.message,

            isfalse: true
          }));
          setIsLoading(false)
        }
        break;

      case "PASSPORTVERIFICATION":
        let expr = /^[A-Z0-9]{6,15}$/;
        // //""
        if (!onChangeDta?.number?.match(/^[a-z0-9]+$/i)) {
          setIsLoading(false)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Please enter a valid Passport File Number",

            isfalse: true
          }));
          return 0

        }
        // else if (!expr.test(onChangeDta.passport_no)) {

        //   setIsLoading(false)
        //   // //console.log(!expr.test(onChangeDta.passport_no), onChangeDta.passport_no)
        //   setShowAlert((pre) => ({
        //     ...pre,
        //     show: true,
        //     message: "Please enter a valid Passport  Number",

        //     isfalse: true
        //   }));
        //   return 0
        // }
        // else if (onChangeDta.passport_no.length <= 7) {
        //   setIsLoading(false)
        //   setShowAlert((pre) => ({
        //     ...pre,
        //     show: true,
        //     message: "Passport Number should be contain atleast 8 charcters",

        //     isfalse: true
        //   }));
        //   return 0
        // }
        else if (!onChangeDta.dob) {
          setIsLoading(false)
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Please enter the Date of Birth",

            isfalse: true
          }));
          return 0
        }
        param = {
          // type: "passport",
          file_number: onChangeDta.number,
          dob: moment(onChangeDta.dob).format("YYYY-MM-DD"),
          // passport_no: onChangeDta.passport_no,
          // UserId: getLocalStorage("clientId"),
        };
        result = await ManageApis(
          "post",
          `${global.fetchPassport}`,
          param,{
            'Content-Type': 'application/json',
            "UserId": getLocalStorage("clientId"),
            "AccountId": getLocalStorage("accountsId")
          }
        );
        if (result.message === "Success" && result?.response_data?.message !== "Your trying limit is over, please contact with support team." && result?.response_data?.message !== "Menu Not Found" && result?.response_data?.status !== 'Failed') {

          setResponse(result.response_data);
          setIsVerified(true)
          setIsLoading(false)
        } else {
          // //console.log(result)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: result.message == "Success" ? result?.response_data?.message == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" : result.response_data?.message : result.message,

            isfalse: true
          }));
          setIsLoading(false)
        }

        break;

      case "PANVERIFICATIONV4":
        let regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        // ""
        if (!regex.test(onChangeDta?.panno)) {
          setIsLoading(false)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Please enter a valid PAN Number",
            isfalse: true
          }));
          return 0
        } else if (onChangeDta?.panno.length <= 9) {
          setIsLoading(false)
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "PAN No should be contain atleast 10 number",

            isfalse: true
          }));
          return 0

        }
        let panReqst = {
          "pan": onChangeDta?.panno,
          // "UserId": getLocalStorage("clientId")
        };
        let headers = {
          headers: {

            'Content-Type': 'application/json',
            "UserId": getLocalStorage("clientId"),
            "AccountId": getLocalStorage("accountsList")[0]?.id

          }
        };
        result = await ManageApis(
          "post",
          `${global.fetchPanV4Details}`, panReqst, {

          'Content-Type': 'application/json',
          "UserId": getLocalStorage("userId"),
          "AccountId": getLocalStorage("oldAccountId")


        }

        );
        
        if (result.message === "Success" && result.response_data !== "Your trying limit is over, please contact with support team." && result.response_data !== "Menu Not Found"&&result?.response_data?.status=="Success") {
          const { address, ...rest } = result.response_data?.data || {}
            
          setResponse(() => ({ data: { ...address, ...rest } }));
          setIsVerified(true)
          setIsLoading(false)
        } else {
          // //console.log(result)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: result.message == "Success" ? result.response_data == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" : typeof result.response_data=="string"? result.response_data:result.response_data.message: result.message,

            isfalse: true
          }));
          setIsLoading(false)
        }

        break;
        case "PANCARDVERIFICATION":
          let pancardverificationRegx = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
          // ""
          if (!pancardverificationRegx.test(onChangeDta?.panno)) {
            setIsLoading(false)
  
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Please enter a valid PAN Number",
              isfalse: true
            }));
            return 0
          } else if (onChangeDta?.panno.length <= 9) {
            setIsLoading(false)
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "PAN No should be contain atleast 10 number",
  
              isfalse: true
            }));
            return 0
  
          }
           request_body = {
            "pan": onChangeDta?.panno,
            // "UserId": getLocalStorage("clientId")
          };
          //  headers = {
          //   headers: {
  
          //     'Content-Type': 'application/json',
          //     "UserId": getLocalStorage("clientId"),
          //     "AccountId": getLocalStorage("accountsList")[0]?.id
  
          //   }
          // };
          result = await ManageApis(
            "post",
            `${global.fetchPanDetails}`, request_body, {
  
            'Content-Type': 'application/json',
            "UserId": getLocalStorage("userId"),
            "AccountId": getLocalStorage("oldAccountId")
  
  
          }
  
        );
          if (result.message === "Success" && result?.response_data?.message !== "Your trying limit is over, please contact with support team." && result?.response_data?.message !== "Menu Not Found" && result?.response_data?.status !== 'Failed') {
            setResponse(result.response_data);
            setIsVerified(true)
            setIsLoading(false)
          } else {
            // //console.log(result)
  
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.message == "Success" ? result?.response_data?.message == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" : result?.response_data?.message : result.message,
  
              isfalse: true
            }));
            setIsLoading(false)
          }
  
          break;
        case "RCVERIFICATION":
          let rcNumberRegx =/^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;
          // ""
          if (!rcNumberRegx.test(onChangeDta?.vehicle_number)) {
            setIsLoading(false)
  
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Please enter a valid RC Number",
              isfalse: true
            }));
            return 0
          } 
            request_body = {
            vehicle_number: onChangeDta?.vehicle_number,
            // "UserId": getLocalStorage("clientId")
          };
          //  headers = {
          //   headers: {
  
          //     'Content-Type': 'application/json',
          //     "UserId": getLocalStorage("clientId"),
          //     "AccountId": getLocalStorage("accountsList")[0]?.id
  
          //   }
          // };
          result = await ManageApis(
            "post",
            `${global.rcVerification}`, request_body, {
  
            'Content-Type': 'application/json',
            "UserId": getLocalStorage("clientId"),
            "AccountId": JSON.parse(getLocalStorage("accountsList"))[0]?.id
  
  
          }
  
          );
          if (result.message === "Success" && result.response_data.message !== "Your trying limit is over, please contact with support team." && result.response_data.message !== "Menu Not Found"  && result.response_data.status !== 'Failed') {     
            let data = result.response_data.data
            setResponse(result);
            setIsVerified(true)
            setIsLoading(false)
          } else {
            // //console.log(result)
  
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.message == "Success" ? result.response_data.message == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" :result.response_data.status === 'Failed' ? result.response_data.message : result.response_data.message : result.message,
  
              isfalse: true
            }));
            setIsLoading(false)
          }
  
          break;
          case "BANKACCOUNTVERIFICATION":            
            // Check if all fields are empty
            if (!onChangeDta?.username && !onChangeDta?.mobileNumber && !onChangeDta?.accountNumber && !onChangeDta?.ifscCode) {
              setIsLoading(false);
              setShowAlert((pre) => ({
                  ...pre,
                  show: true,
                  message: "Please fill in all the required fields",
                  isfalse: true
              }));
              return 0;
          }
        // Username validation: only letters are allowed, no numbers or special characters
          let usernameRegex = /[^a-zA-Z\s]/g;
          if (usernameRegex.test(onChangeDta?.username)) {
            setIsLoading(false);
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Username should only contain letters (A-Z, a-z), no numbers or special characters",
              isfalse: true
            }));
            return 0;
          }
          
          // Mobile number validation: only digits are allowed, no letters or special characters
          let mobileNumberRegex = /^\d{10}$/;
          if (!mobileNumberRegex.test(onChangeDta?.mobileNumber)) {
            setIsLoading(false);
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Please enter a valid 10-digit mobile number",
              isfalse: true
            }));
            return 0;
          }

          // Regex to check valid bank account number, this is a placeholder. Adjust as per your requirement.
          let bankAccountRegex = /^[0-9]{9,18}$/;

          if (!bankAccountRegex.test(onChangeDta?.accountNumber)) {
            setIsLoading(false);
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Please enter a valid Bank Account Number",
              isfalse: true
            }));
            return 0;
          }

          let ifscCodeRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
          if (!ifscCodeRegex.test(onChangeDta?.ifscCode)) {
            setIsLoading(false);
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: "Please enter a valid 11-character IFSC code (4 letters, followed by 0, then 6 alphanumeric characters)",
              isfalse: true
            }));
            return 0;
          }

          param = {
          bank_account: onChangeDta.accountNumber,
          ifsc: onChangeDta.ifscCode,
          name: onChangeDta.username,
          phone: onChangeDta.mobileNumber,

        };
        result = await ManageApis(
          "post",
          `${global.bankAccountVerification}`,
          param,{

            'Content-Type': 'application/json',
            "UserId": getLocalStorage("clientId"),
            "AccountId": JSON.parse(getLocalStorage("accountsList"))[0]?.id
          }
        );
        if (result.message === "Success" && result.response_data.message !== "Your trying limit is over, please contact with support team." && result.response_data.message !== "Menu Not Found" && result.response_data.status !== 'Failed') {

          setResponse(result.response_data);
          setIsVerified(true)
          setIsLoading(false)
        } else {
          // //console.log(result)

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: result.message == "Success" ? result.response_data.message == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team":result.response_data.status === 'Failed' ? result.response_data.message : result.response_data.message : result.message,
            isfalse: true
          }));
          setIsLoading(false)
        }

        break;
        case "VOTERIDVERIFICATION":
            if (!onChangeDta?.number || onChangeDta?.number.length < 10) {
              setIsLoading(false)
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: "Please enter a valid Voter ID",

                isfalse: true
              }));
              return 0
            }

            param = {
              voterIDNo: onChangeDta?.number,
              // type: "voter card",
              // UserId: getLocalStorage("clientId")
            };
            result = await ManageApis(
              "post",
              `${global.fetVoterId}`,
              param,{
                'Content-Type': 'application/json',
                "UserId": getLocalStorage("clientId"),
                "AccountId": getLocalStorage("accountsId")
              }
        );
            if (result.message === "Success" && result.response_data?.message !== "Your trying limit is over, please contact with support team." && result.response_data?.message !== "Menu Not Found" && result?.response_data?.status !== 'Failed' ) {
              setResponse(result.response_data);
              setIsVerified(true)
              setIsLoading(false)
            } else {
              // //console.log(result)
              setIsLoading(false)

              setShowAlert((pre) => ({
                ...pre,
                show: true, 
                message: result.message == "Success" ? result?.response_data?.message == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team" : result?.response_data?.message : result.message,

                isfalse: true
              }));
            }

            break;

      default:
        break;
    }
  };

  const handleOtpSubmit = async () => {

    switch (selectedMenu) {
      case "AADHARVERIFICATION":
        if (otp.join('')?.length >= 4) {
          setIsLoading(true)
          const reqstData = {
            share_code: "1542",
            otp: otp.join(''),
            ref_Id: response?.data?.referenceId,
            UserId: getLocalStorage("clientId")
          };
          let result = await ManageApis(
            "post",
            `${global.submitAadhar}`,
            reqstData,
            {
              "Content-Type": "application/json",
              UserId: getLocalStorage("userId"),
              AccountId: getLocalStorage("oldAccountId"),
              // "AccountId": JSON.parse(getLocalStorage("accountsList"))[0]?.id
            }
          );
          if (result.message === "Success" && result.response_data !== "Your trying limit is over, please contact with support team." && result.response_data.status !=='Failed') {
            setHaveOTPSection(false);
            setResponse(result.response_data);
            setIsVerified(true)
            // //console.log(result.response_data);
            setIsLoading(false)
          } else {
            setIsLoading(false)
            // //console.log(result)
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.message === "Success" ? result.response_data == "Your trying limit is over, please contact with support team." ? "Your trying limit is over, please contact with support team." : "Offline Aadhaar process failed - Enter valid details." : result.message,

              isfalse: true
            }));

          }
        }

        break;

      default:
        break;
    }
  };

  const handleChange = (event, max, regex) => {
    
    const { name, value } = event.target;
    console.log("----------->",value );
    const cleanedVal = UsernameformatingValue(value, max, regex)
    console.log({cleanedVal})
    console.log(name == 'username', {cleanedVal},{max}, {regex})
    const sanitaizedValue = regex ?  name == 'username' ? formatingValue(cleanedVal,max, regex) : formatingValue(value, max, regex).trim().toUpperCase() : value.trim().
    toUpperCase()
    console.log({sanitaizedValue})
    setOnChangeDta((prev) => ({
      ...prev,
      [name]: sanitaizedValue        //regex.test(value)?value.slice(0, max):value.replace(regex,""),
    }));
  };

  useEffect(() => {
    if (onChangeDta) {
      
      console.log({onChangeDta})
    }
  }, [onChangeDta])
  


  const handleOtpChange = (e, index) => {
    //""
    const value = e.target.value;
    if (value.length === 1 || value == "") {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);
      // Add any other logic you need
    }
  };


  return (
    <>
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={() => setShowAlert(AlertinitialValue)}
      />

      {isLoading && <Loader />}
      <div className="px-3 flex-fill">
        <HeaderSection headerName={headerName} handleToggleBtn={() => setisToggled(!isToggled)} />
        {/* <div className="main__section bg-white overflow-hidden w-100 px-4 py-3 br_15 h-100"> */}
        {!isVerified ? (
          <div className="h-100 ">
            <div className="">
              {/* <div className="text-center d-block d-md-none">
                <h2 className="font_22 text_master2 fw-bold mb-3">
                  {selectedMenu}
                </h2>
              </div> */}

              <div className="bg-white shadow_sm4 br_10 verification__section  px-0 px-md-4 py-0 py-md-2 verif_main">
                <div className="d-flex">
                  {/* <div className="d-none d-md-block me-5 my-auto pe-4 w-50">
                      <h3 className="fw-bold h2 text_gray1">{discriptionHead}</h3>
                      <p className="font_14">
                        {discription}
                      </p>
                    </div> */}

                  <div className="m-auto verif_right w_60x">
                    <div className="bg-white d-flex br_10 my-4 px-4 py-0 py-md-2 text-center overflow-auto verify_height1 scrollbar1">
                      <div className="m-auto mx-0 w-100 py-3">
                        {selectedMenu == "AADHARVERIFICATION" ? (
                          !haveOTPSection ? (
                            <VerificationInput
                              headerName={headerName}
                              handleSubmit={handleSubmit}
                              fieldsList={fields}
                              handleChange={handleChange}
                              value={onChangeDta}
                            />
                          ) : (
                            // OTP SECTION
                            <VerificationOtp
                              OtpOnchange={handleOtpChange}
                              handleSubmit={handleOtpSubmit}
                              otp={otp}
                              setOtp={setOtp}
                            />
                          )
                        ) : (
                          <VerificationInput
                            headerName={headerName}
                            handleSubmit={handleSubmit}
                            fieldsList={fields}
                            handleChange={handleChange}
                            value={onChangeDta}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          //  EXTRACTED DATA SECTION

          // isVerified && <VerificationOutPut header={headerName} setIsVerified={setIsVerified} responseData={response} />
          isVerified && <VerificationOutPut header={headerName} setIsVerified={setIsVerified} responseData={response} />
        )}
        {/* </div> */}
      </div>
    </>
  );
}

export default VerificationScreen;
